/* global Survey */

const widget = {
    name: "mybootstrapdatepicker",
    title: "My Bootstrap Date",
    iconName: "",
    widgetIsLoaded: function () {
        return true;
    },
    isFit: function (question) {
        return question.getType() === "mybootstrapdatepicker";
    },
    activatedByChanged: function () {
        Survey.JsonObject.metaData.addClass(
            "mybootstrapdatepicker",
            [],
            null,
            "text"
        );
    },
    isDefaultRender: false,
    htmlTemplate: `
<div>
  <input placeholder='Select Date' class='form-control' data-provide="datepicker" data-date-format="dd/mm/yyyy" />
</div>`,
    afterRender: function (question, el) {
        const textLookup = el.getElementsByTagName("input")[0];
        textLookup.inputType = question.inputType;

        textLookup.onchange = function () {
            question.value = textLookup.value;
        };

        const onReadOnlyChangedCallback = () => {
            if (question.isReadOnly) {
                textLookup.setAttribute("disabled", "disabled");
            } else {
                textLookup.removeAttribute("disabled");
            }
        };
        question.readOnlyChangedCallback = onReadOnlyChangedCallback;
        onReadOnlyChangedCallback();
    },
    willUnmount: function () {
        return null;
    },
};

// Register our widget in singleton custom widget collection
Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, "customtype");
